import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'
$("header .nav ul li").eq(0).addClass("active");

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 5000, 
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
	// 使用自定义分页器
  pagination: {
    el: '.custom-pagination',
    type: 'custom',
    renderCustom: function(swiper, current, total) {
      let paginationHTML = '';
      
      for (let i = 0; i < total; i++) {
        const isActive = (swiper.realIndex === i);
        const progressValue = isActive ? 
          ((swiper.autoplay.timeLeft / swiper.params.autoplay.delay) * 100) : 0;
        
        paginationHTML += `
          <div class="progress-pagination-item ${isActive ? 'active' : ''}">
            <svg class="progress-circle" width="40" height="40" viewBox="0 0 40 40">
              <circle class="progress-bg" cx="20" cy="20" r="18"></circle>
              <circle 
                class="progress-fill" 
                cx="20" 
                cy="20" 
                r="18"
                style="--progress: ${progressValue}"
              ></circle>
            </svg>
            <span class="progress-number">0${i + 1}</span>
          </div>
        `;
      }
      
      return paginationHTML;
    }
  },
  
  // 监听事件更新进度
  on: {
    autoplayTimeLeft(swiper, timeLeft, percentage) {
      const activeIndex = swiper.realIndex;
      const progressItems = document.querySelectorAll('.progress-fill');
      
      if (progressItems[activeIndex]) {
        const progress = percentage * 100;
        progressItems[activeIndex].style.setProperty('--progress', progress);
      }
    },
    
    slideChange(swiper) {
      // 重置所有进度条
      const progressItems = document.querySelectorAll('.progress-fill');
      progressItems.forEach(item => {
        item.style.setProperty('--progress', '0');
      });
      
      // 激活当前进度条
      const activeIndex = swiper.realIndex;
      if (progressItems[activeIndex]) {
        progressItems[activeIndex].style.setProperty('--progress', '100');
      }
    }
  }

}); 

 var product = new Swiper('.section2 .mySwiper', {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: '1.21%',
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: '1.21%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: '1.21%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
      }
    },
    navigation: {
        nextEl: ".section2 .swiper-button-next",
        prevEl: ".section2 .swiper-button-prev",              
    },
});

var swiper1 = new Swiper(".section4 .swiper1", {
  loop:true,
  speed:10000,//匀速时间
  autoplay: {
    delay: 0,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
  breakpoints: {
    1280: {  //当屏幕宽度小于等于1280
      slidesPerView: 3,
      spaceBetween: 150,
    },
    768: {  //当屏幕宽度小于等于768
      slidesPerView: 2,
      spaceBetween: 100,
    },
    320: {  //当屏幕宽度小于等于320
      slidesPerView: 1,
      spaceBetween: 0,
    }
  } 
});
var swiper2 = new Swiper(".section4 .swiper2", {
  loop:true,
  speed:10000,//匀速时间
  autoplay: {
    delay: 0,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    reverseDirection: true,
  },
  breakpoints: {
    1280: {  //当屏幕宽度小于等于1280
      slidesPerView: 3,
      spaceBetween: 150,
    },
    768: {  //当屏幕宽度小于等于768
      slidesPerView: 2,
      spaceBetween: 100,
    },
    320: {  //当屏幕宽度小于等于320
      slidesPerView: 1,
      spaceBetween: 0,
    }
  } 
}); 


// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s > $(".section6").offset().top + $("header").height()  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s >$(".section6").offset().top + $("header").height()  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})

 var mes = new Swiper('.section9 .swiper', {
    loop:true,
    navigation: {
        nextEl: ".section9 .swiper-button-next",
        prevEl: ".section9 .swiper-button-prev",              
    },
    breakpoints: {
    1280: {  //当屏幕宽度小于等于1280
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 30,
    },
    768: {  //当屏幕宽度小于等于768
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 30,
    },
    320: {  //当屏幕宽度小于等于320
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
    }
  } 
});